import { REQUIRED_ONBOARDING } from 'pricing-pages-api/EarlyRequesterNames';
import { GET_REQUIRED_ONBOARDING } from 'pricing-pages-api/required-onboarding/queries';
import { getPublicMetaData } from 'pricing-pages-lib/api/PublicMetaDataApi';
import { dataFetchingClient } from '../utils/dataFetchingClient';
import { PUBLIC } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { FetchRequiredOnboardingActions } from './RequiredOnboardingActions';
export const FetchPublicMetaDataRequestTypes = createRequestTypes(PUBLIC);
export const FetchPublicMetaDataActions = createRequestActions(FetchPublicMetaDataRequestTypes);
export const fetchPublicMetaData = () => {
  return dispatch => {
    dispatch(FetchPublicMetaDataActions.request());
    dispatch(FetchRequiredOnboardingActions.request());
    return getPublicMetaData().then(resp => {
      dispatch(FetchPublicMetaDataActions.receive());
      const {
        requiredOnboardingResult
      } = resp;
      dispatch(FetchRequiredOnboardingActions.receive({
        requiredOnboarding: requiredOnboardingResult
      }));
      dataFetchingClient.writeQuery({
        query: GET_REQUIRED_ONBOARDING,
        data: {
          requiredOnboarding: requiredOnboardingResult
        },
        variables: {
          earlyRequestName: REQUIRED_ONBOARDING
        }
      });
    }).catch(error => {
      dispatch(FetchPublicMetaDataActions.failure(error));
      dispatch(FetchRequiredOnboardingActions.failure(error));
      throw error;
    });
  };
};